if( page_name== 'Free-Cart')
{
  $( window ).on("load", function() {
    $(".overlay").show();
    var customerId = meta.page.customerId;
    if (customerId == undefined){
    	var link = 'https://ffp.stellar-soft.com/api/emptycart';
        $.ajax({
              type: "POST",
              url: link,
              success: function(response) {
                  setTimeout(function() {$('.overlay').hide();}, 1000);
                  $('#cart_page_template').html(response);
              }
        });
    }
    else if(customerId !== '')
    {
      var link = 'https://ffp.stellar-soft.com/api/cart/' + customerId;
      $.ajax({
            type: "POST",
            url: link,
            success: function(response) {
              	setTimeout(function() {$('.overlay').hide();}, 2000);
                $('#cart_page_template').html(response);
            }
      });
    }
  });
}

$(document).ready(function() {
     
 $('body').on('click', '#try_home', function () {
     	 $(".overlay").show();
    	 var productId = meta.product.id;
   		 var customerId = meta.page.customerId;
    	 var action_url = 'https://ffp.stellar-soft.com/api/addcart';
    	 $.ajax({
           		type: "POST",
                url: action_url,
                dataType: "json",
           		data: $("#product_form_"+ productId).serialize() + "&product_id="+productId + "&customer_id="+customerId,
           		success: function(data) {
                  if(data.status == 'full'){
					msg = '<div class="alert alert-success">' + data.message + '</div>';
                  	$('#form_result').html(msg);
                    $('#tryhomefree').modal('show');
                    setTimeout(function() {$('.overlay').hide();}, 1000);
                    window.location.href="/pages/free-cart";
                  }
                  else if(data.status == 'false'){
                    msg = '<div class="alert alert-danger">' + data.message + '</div>';
                    $('#tryhomefree').modal('show');
                    setTimeout(function() {$('.overlay').hide();}, 1000);
                    $('#form_result').html(msg);
                  }else if(data.status == 'true'){
                    msg = '<div class="alert alert-success">' + data.message + '</div>';
                  	$('#form_result').html(msg);
                    $('#tryhomefree').modal('show');
                    setTimeout(function() {$('.overlay').hide();}, 1000);
                    window.location.href="/collections";
                  }
                }
         });
 });
});



if( page_name== 'Free-Cart')
{
  $('body').on('click', '.removecart_item', function(){
    	$(".overlay").show();
        var customerId = meta.page.customerId;
        var variation_id = $(this).attr('id');
          $.ajax({
            type: "POST",
            url: "https://ffp.stellar-soft.com/api/remove_cart/" + variation_id + '/'+ customerId,
            success: function (data) {  
              if(data.count == '0'){
              		$('.removecart' + variation_id).remove();
                	setTimeout(function() {$('.overlay').hide();}, 1500);
                 	window.location.href="/pages/free-cart";
              }else{
                $('.removecart' + variation_id).remove();
                $('#final_amount').html(data.currency + '' + data.price);
                $('#free_cart_items').html(data.cart_total_items);
                setTimeout(function() {$('.overlay').hide();}, 1500);
              }
            }
          });
  });
}


if( page_name== 'Free-Cart')
{
  $('body').on('click', '.Get_Checkout', function(event){
    	event.preventDefault();
    	if($("#terms").prop('checked') == false)
        {
          alert('Please, accept terms and conditions');
        }
        else{
            var customerId = meta.page.customerId;
            $.ajax({
                    type: "POST",
                    url: "https://ffp.stellar-soft.com/api/checkoutdetails/" + customerId,
                    success: function (data) {  
                        window.location = "https://ffp.stellar-soft.com/checkout/" + data.customer_id;
                    }
             });
        }
  });
}



$( window ).on("load", function() {
    var customerId = meta.page.customerId;
    if (customerId !== ''){
    var link = 'https://ffp.stellar-soft.com/api/countcart/' + customerId;
        $.ajax({
              type: "POST",
              url: link,
              success: function(response) {                	
                  $('#free_cart_items').html(response.cart_items);
              }
        });
    }else if(customerId == undefined){
      	$('#free_cart_items').html(0);
    }
});


if( page_name== 'Home-Try-Orders')
{
  $( window ).on("load", function() {
    $(".overlay").show();
    var customerId = meta.page.customerId;
    if(customerId == undefined){
        setTimeout(function() {$('.overlay').hide();}, 1000);
      	$('#order_page_template').html('Orders Not Found!');
    }
	else if(customerId !== '')
    {
      var link = 'https://ffp.stellar-soft.com/api/orders/' + customerId;
      $.ajax({
            type: "POST",
            url: link,
            success: function(response) {
               	setTimeout(function() {$('.overlay').hide();}, 2000);
                $('#order_page_template').html(response);
            }
      });
    }
  });
    
  $(document).ready(function() {
	$('body').on('click', '#draft_order_id', function(event){
    	event.preventDefault();
    	var draft_id = $(this).html();
        window.location.href="/pages/view-order?draft_id="+draft_id;
  	});
  });
}

if( page_name== 'View-Order'){
  $(".overlay").show();
  var parts = window.location.href.split('draft_id=', 2);
  var draft_id = parts[1];
  var link = 'https://ffp.stellar-soft.com/api/viewcart/' + draft_id;
  $.ajax({
      type: "POST",
      url: link,
      success: function(response) {   
        $('#view_order_data').attr('style', function(i, style){
            return style && style.replace(/display[^;]+;?/g, '');
        });
        setTimeout(function() {$('.overlay').hide();}, 2000);
        $('#view_order_data').html(response);
      }
  });
}